import { ChangeDetectorRef, Component, ElementRef, OnDestroy } from '@angular/core';
import { BaseWidget } from '../../view-container-package/widegt';
import { TabToolbarItem } from '../../../interface/tool-bar';
import { ToolbarConfigService } from '../../../nav-data/tool-bar';
import { Subscription } from 'rxjs';

/**
 * 导航面板工具栏组件
 * @remarks
 * 导航面板标题栏右侧的工具栏图标
 * 通过工具栏可以配置一些常用功能（如：新增文件、刷新导航树、全部展开/收折）
 */
@Component({
  selector: 'tool-bar',
  templateUrl: './tool-bar.html'
})
export class TabBarToolbar extends BaseWidget implements OnDestroy {

  items: TabToolbarItem[] = [];

  private configService: ToolbarConfigService;

  private configUpdatedSubscription: Subscription;

  constructor(
    private el: ElementRef,
    private cd: ChangeDetectorRef
  ) {
    super();
  }

  /**
   * 设置工具栏配置服务
   * @param configService 工具栏配置服务
   */
  public setConfigService(configService: ToolbarConfigService): void {
    if (!configService) {
      return;
    }
    this.configService = configService;
    this.items = this.configService.getToolbarItems();
    if (!!this.configUpdatedSubscription) {
      this.clearSubscription();
    }
    this.configUpdatedSubscription = this.configService.updated.subscribe(() => {
      this.items = this.configService.getToolbarItems();
      this.cd.markForCheck();
      this.cd.detectChanges();
    });
  }

  private clearSubscription(): void {
    if (!!this.configUpdatedSubscription) {
      this.configUpdatedSubscription.unsubscribe();
      this.configUpdatedSubscription = null;
    }
  }

  ngOnDestroy(): void {
    this.clearSubscription();
  }

  protected onAfterAttach(): void {
    this.node.appendChild(this.el.nativeElement);
  }

  /**
   * 判断自己是否被点击
   * @param event 点击事件
   * @returns 是否被点击
   */
  public shouldHandleMouseEvent(event: MouseEvent): boolean {
    return event.target instanceof Element && this.node.contains(event.target);
  }

  handleItemClick(item: TabToolbarItem): void {
    const command = item.command;
    this.configService && this.configService.executeCommand(command);
  }

}
